import { Injectable, inject } from '@angular/core';
import { Document } from '../models/document.model';
import { BASE_ONBOARDING_DOCUMENTS, QUOTEDEVIL_OVERRIDES } from '../modules/onboarding/pages/onboarding-page/onboarding-documents.config';
import { ClientConfigService } from './client-config.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardingDocumentsService {
  private clientConfig = inject(ClientConfigService);

  getDocuments(): Document[] {
    const brokerId = this.clientConfig.getBrokerId();
    // Deep clone the base documents array to avoid mutating the constant
    let docs: Document[] = JSON.parse(JSON.stringify(BASE_ONBOARDING_DOCUMENTS));

    if (brokerId === '04') {
      docs = docs.map(doc => {
        const override = QUOTEDEVIL_OVERRIDES[doc.name];
        return override ? { ...doc, ...override } : doc;
      });
    }

    return docs.filter(doc => !doc.disabled);
  }
}
